module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "killerFeatureGenAI.7ec76e29.png";